import React, { useState } from "react";
import Team from "../../components/about/Team";
import Partners from "../../components/partners/Partners";
import About_news from "../../components/blog/about_news";
import Story from "../../components/about/Story";
import Head from "next/head";
import Meta from "../../components/Meta";

const About = () => {
  const [video, setVideo] = useState(false);
  return (
    <>
      <Meta title="Smart Swap || Reflectdoge" />
      {/* <!-- Page title --> */}
      <section className="relative pt-24">
        <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 block dark:hidden h-full">
          <img
            src="/images/gradient.jpg"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block">
          <img
            src="/images/gradient_dark.jpg"
            alt="gradient dark"
            className="h-full w-full"
          />
        </picture>

        <iframe
          className="h-[1281px] pt-8"
          title="Embedded Content"
          name="htmlComp-iframe"
          width="100%"
          height="100%"
          allow="fullscreen"
          data-src=""
          src="https://mannaushack.nftify.network/box-event/63936036b6edfec3885f2d48"
        ></iframe>
      </section>
    </>
  );
};

export default About;
